import { InjectionToken } from '@angular/core';

export const APP_STORAGE = new InjectionToken<Storage>('app-storage');

export enum AppStorage {
  AccessToken = 'cb:access-token',
}
